import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../../config/apiConfig";
import { saveUserToken } from "../../../utils/auth";

const CuppatradeRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Use ref to track whether the API call has been made
  const isCalled = useRef(false);

  useEffect(() => {
    if (isCalled.current) return; // Prevent duplicate calls
    isCalled.current = true;

    const params = new URLSearchParams(location.search);
    const name = params.get("name");
    const email = params.get("EmailId");
    const phone = params.get("MobileNo");

    if (!email) {
      alert("Missing Email!");
      return;
    }

    axios
      .get(`${BASE_URL}/api/user/cuppatrade/check-user`, {
        params: { name, EmailId: email, MobileNo: phone },
      })
      .then((res) => {
        const { status, token } = res.data;

        if (status === "login") {
          if( token){
            try {
              saveUserToken(token, email);
              // alert("Login successful!");
              navigate("/user/home");
            } catch (error) {
              console.error("Failed to save token:", error);
              // alert("Error saving session. Try logging in.");
            }
          }
        } else if (status === "signup") {
          if (token) {
            try {
              saveUserToken(token, email);
              // alert("Your login credentials have been sent to your email.");
              navigate("/user/home");
            } catch (error) {
              console.error("Failed to save token:", error);
              // alert("Error saving session. Try logging in.");
              navigate("/cuppatrade/login", { state: { email } });
            }
          }
        } else {
          alert("Unexpected response from server.");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        alert("Something went wrong. Try again.");
      });
  }, [location.search, navigate]);

  return <p>Redirecting...</p>;
};

export default CuppatradeRedirect;
